(function (angular) {
  'use strict';

  /**
                 * @ngdoc overview
                 * @name gplans.intercom
                 * Enables analytics support for Intercom (https://www.intercom.io/)
                 */
  angular.module('gplans.intercom', ['angulartics']).
  constant('IntercomConfiguration', {
    'APP_ID': 'nkg8poqg' }).

  config(['$analyticsProvider', function ($analyticsProvider) {

    // $analyticsProvider.registerSetUsername(function (userId) {
    //   if(window.Intercom && window.Intercom.booted) {
    //     window.Intercom('update', { user_id: userId });
    //   }
    // });

    $analyticsProvider.registerSetUserProperties(function (props) {
      if (window.Intercom && window.Intercom.booted) {
        window.Intercom('update', props);
      }
    });

    /**
         * Track Event in Intercom
         * @name eventTrack
         *
         * @param {string} action Required 'action' (string) associated with the event
         * @param {object} properties = metadata
         *
         * @link http://doc.intercom.io/api/?javascript#submitting-events
         *
         * @example
         *   Intercom('trackEvent', 'invited-friend');
         */
    $analyticsProvider.registerEventTrack(function (action, properties) {
      if (window.Intercom && window.Intercom.booted) {
        window.Intercom('trackEvent', action, properties);
      }
    });

    /**
         * Update Intercom on Page View
         * @name pageTrack
         * Update is required on page change.
         *
         * @link https://docs.intercom.io/install-on-your-product-or-site/other-ways-to-get-started/integrate-intercom-in-a-single-page-app
         *
         * @example
         *   Intercom('update');
         */
    $analyticsProvider.registerPageTrack(function (path) {
      if (window.Intercom && window.Intercom.booted) {
        window.Intercom('update');
      }
    });
  }]);
})(angular);